import * as React from 'react';
import TheSlider from '@react-native-community/slider';
const Slider = props => <TheSlider {...props} />;
export default Slider;
